import { Avatar, Box } from "@mui/material"

const userInfoColumn = {
    field: 'fullName',
    headerName: 'User Information',
    width: 190,
    editable: true,
    headerAlign: 'center',
    align: 'left',
    renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar src={params.row.userPhoto || ''} sx={{ mr: 1, height: 30, width: 30 }} />
            {params.row.fullName}
        </Box>
    ),
}

export { userInfoColumn }